import {GenericDropdownController} from '../GenericDropdown/GenericDropdown';
import IVueComponent from '../../adapters/IVueComponent';
import {html} from './MultiSelectionDropdown.html';
import {method, prop} from '../../adapters/VueComponent';
import {Collection} from '../../models/Collection';


class MultiSelectionDropdownController extends GenericDropdownController {
    @prop({
        emit:true
    })
    override selected: any[];

    @method()
    override isSelected(item: any) {
        if (!item && this.none) {
            return this.selected.length == 0;
        }

        if (!this.selected) {
            return false;
        }

        for (const selected of this.selected) {
            if (this.isItemSelected(selected, item)) {
                return true;
            }
        }

        return false;
    }

    @method()
    override select(item: any): void {
        if (!item && this.none) {
            this.selected = [...this.items];
            if (this.triggerFunction) {
                if (this.triggerScope) {
                    this.triggerFunction(item, this.triggerScope);
                }
                else {
                    this.triggerFunction(item);
                }
            }
            
            return;
        }

        if (this.selected.indexOf(item) != -1) {
            this.selected.splice(this.selected.indexOf(item), 1);
        }
        else {
            this.selected.push(item)
        }

        if (this.triggerFunction) {
            if (this.triggerScope) {
                this.triggerFunction(item, this.triggerScope);
            }
            else {
                this.triggerFunction(item);
            }
        }
    }

    override getSelectedName(item: any) {
        if (this.selected.length == 0 && this.none) {
            return this.none;
        }

        return this.selected.map(v => this.getName(v)).join(', ');
    }

    @method()
    override display(item) {
        if (!this.search || !this.query) {
            return true;
        }

        let name = super.getSelectedName(item);
        return name && name.toLowerCase().indexOf(this.query.toLowerCase()) === 0;
    }
}

export default function MultiSelectionDropdown(): IVueComponent {
    return {
        controller: MultiSelectionDropdownController,
        template: html,
        tag: 'multi-selection-dropdown'
    };
}
